import React, { Fragment, useState } from "react";
import { Col, Row, Card, CardBody, Button, Table, Container } from 'reactstrap';
import { DatePicker, KeyboardDateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { withStyles } from '@material-ui/core/styles';
import RipsApi from '../../api/RipsApi';
import Spinner from 'react-bootstrap/Spinner';
import moment from "moment";

const MedicalCheckbox = withStyles({
    root: {
        '&$checked': {
            color: '#4ce1b6',
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

const RIPSpecificParameters = () => {
    const [dates, setDates] = useState({ startDate: null, endDate: null });
    const [isLoading, setIsLoading] = useState(false);
    const [searchByForeignPatient, setSearchByForeignPatient] = useState(false);
    //Checkbox de RIPS
    const [AF, setAF] = useState(false);
    const [US, setUS] = useState(false);
    const [AC, setAC] = useState(false);
    const [AP, setAP] = useState(false);
    const [AD, setAD] = useState(false);
    const [AM, setAM] = useState(false);
    const [AH, setAH] = useState(false);//No Disponible
    const [AN, setAN] = useState(false);//No disponible
    const [AT, setAT] = useState(false);//No disponible
    const [AU, setAU] = useState(false);//No disponible
    const [CT, setCT] = useState(true);//Control

    const downloadZIP = async () => {
        setIsLoading(true);
        let fechaInicial = moment(dates.startDate).format('YYYY/MM/DD');
        let fechaFinal = moment(dates.endDate).format('YYYY/MM/DD');

        /* 
        val1: req.body.fecha_inicial,
            val2: req.body.fecha_final,
            val3: req.body.id_clinica,
            val4: req.body.archivos_planos,
            val5: req.body.tipos_id_docs
        */
        let archivosPlanos = {
            AF: AF,
            US: US,
            AC: AC,
            AP: AP,
            AD: AD,
            AH: AH,
            AM: AM,
            AN: AN,
            AT: AT,
            AU: AU,
            CT: CT
        };

        let dataSend = {
            fecha_inicial: moment(fechaInicial + " " + "00:00:00").format('YYYY-MM-DD HH:mm:ss'),
            fecha_final: moment(fechaFinal + " " + "23:59:59").format('YYYY-MM-DD HH:mm:ss'),
            id_clinica: sessionStorage.getItem('id_clinica'),
            archivos_planos: archivosPlanos,
            tipos_id_docs: searchByForeignPatient
        }

        await RipsApi.generarArchivosPlanosRIPSEspecificos(dataSend).then(response => {
            let blob = response;
            RipsApi.consultarUltimoConsecutivo().then(resp => {
                if (blob != null) {
                    setIsLoading(false);
                    var url = window.URL.createObjectURL(blob);
                    var a = document.createElement('a');
                    a.href = url;
                    a.download = resp.rip.numero_envio + ".zip";
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    /* if (idThird != null) {
                        getListRegisters(idThird);
                    } */
                }
                else {
                    setIsLoading(false);
                    alert("Ha ocurrido un error generando los RIPS, es posible que no halla cerrado Admisiones o no existan Facturas con los filtros indicados");
                }
            })
        }).catch(err => {
            alert("Ha ocurrido un error generando los RIPS, por favor intente nuevamente");
            console.log(err);
            setIsLoading(false);
        });
    }

    /*  const getListRegisters = async (third) => {
         await RipsApi.listarRegistroRips(third).then(response => {
             setRIPS(response);
         }).catch(error => {
             console.log(error);
         });
     } */

    return (
        <Fragment>
            <Container className="dashboard">
                <Row>
                    <Col md={12}>
                        <h3 className="page-title center-title">RIPS | Parametros Específicos</h3>
                    </Col>
                </Row>
                <Card>
                    <CardBody>
                        <Row className="row-rips">
                            <Col>
                            <h5 style={{ color: '#757575' }}>
                                Seleccione el Rango de Fechas para generar los RIPS.
                            </h5>
                            </Col>
                        </Row>
                        <Row className="row-rips">
                            <Col md={3}>
                                <MuiPickersUtilsProvider utils={MomentUtils} >
                                    <DatePicker
                                        disableFuture
                                        openTo="date"
                                        label="Fecha Inicial"
                                        /* minDate={!!dates.endDate ? moment(dates.endDate).subtract(31, 'days') : moment(new Date()).subtract(31, 'days')}
                                        maxDate={!!dates.endDate ? moment(dates.endDate): moment(new Date()).add(31, 'days')} */
                                        views={["year", "month", "date"]}
                                        value={dates.startDate}
                                        onChange={(date) => {
                                            // handleChangeStartDate(date);
                                            setDates({ ...dates, startDate: new Date(date) })
                                        }}
                                        className='medical-material-form__field'
                                        animateYearScrolling
                                        format="yyyy/MM/D"
                                    />
                                </MuiPickersUtilsProvider>
                            </Col>
                            <Col md={3}>
                                <MuiPickersUtilsProvider utils={MomentUtils} >
                                    <DatePicker
                                        disableFuture
                                        disabled={!dates.startDate}
                                        openTo="date"
                                        label="Fecha Final"
                                        maxDate={!!dates.startDate ? moment(dates.startDate).add(31, 'days') : new Date()}
                                        /* minDate={!!dates.startDate ? moment(dates.startDate) : moment(new Date()).subtract(31, 'days')} */
                                        views={["year", "month", "date"]}
                                        value={dates.endDate}
                                        onChange={(date) => {
                                            // handleChangeEndDate(date);
                                            setDates({ ...dates, endDate: new Date(date) })
                                        }}
                                        className='medical-material-form__field'
                                        animateYearScrolling
                                        format="yyyy/MM/D"
                                    />
                                </MuiPickersUtilsProvider>
                            </Col>
                            <Col md={3}>
                                <FormControlLabel
                                    id={"chkx_foreign_FormLabel"}
                                    value={searchByForeignPatient}
                                    control={
                                        <MedicalCheckbox
                                            id={"chkxForeignPatient"}
                                            checked={searchByForeignPatient}
                                            onChange={(event, check) => {
                                                setSearchByForeignPatient(check);
                                            }}
                                            iconStyle={{ fill: 'green' }}
                                        />
                                    }
                                    label={"Filtrar por pacientes Extranjeros"}
                                    labelPlacement={"end"}
                                />
                            </Col>
                        </Row>
                        <Row className="row-rips">
                            <Row>
                                <Col md={1}>
                                    <FormControlLabel
                                        id={"chkx_AF_FormLabel"}
                                        value={AF}
                                        control={
                                            <MedicalCheckbox
                                                id={"chkxAF"}
                                                checked={AF}
                                                onChange={(event, check) => {
                                                    setAF(check);
                                                }}
                                                iconStyle={{ fill: 'green' }}
                                            />
                                        }
                                        label={"AF"}
                                        labelPlacement={"end"}
                                    />
                                </Col>
                                <Col md={1}>
                                    <FormControlLabel
                                        id={"chkx_US_FormLabel"}
                                        value={US}
                                        control={
                                            <MedicalCheckbox
                                                id={"chkxUS"}
                                                checked={US}
                                                onChange={(event, check) => {
                                                    setUS(check)
                                                }}
                                                iconStyle={{ fill: 'green' }}
                                            />
                                        }
                                        label={"US"}
                                        labelPlacement={"end"}
                                    />
                                </Col>
                                <Col md={1}>
                                    <FormControlLabel
                                        id={"chkx_AC_FormLabel"}
                                        value={AC}
                                        control={
                                            <MedicalCheckbox
                                                id={"chkxAC"}
                                                checked={AC}
                                                onChange={(event, check) => {
                                                    setAC(check)
                                                }}
                                                iconStyle={{ fill: 'green' }}
                                            />
                                        }
                                        label={"AC"}
                                        labelPlacement={"end"}
                                    />
                                </Col>
                                <Col md={1}>
                                    <FormControlLabel
                                        id={"chkx_AP_FormLabel"}
                                        value={AP}
                                        control={
                                            <MedicalCheckbox
                                                id={"chkxAP"}
                                                checked={AP}
                                                onChange={(event, check) => {
                                                    setAP(check)
                                                }}
                                                iconStyle={{ fill: 'green' }}
                                            />
                                        }
                                        label={"AP"}
                                        labelPlacement={"end"}
                                    />
                                </Col>
                                <Col md={1}>
                                    <FormControlLabel
                                        id={"chkx_AD_FormLabel"}
                                        value={AD}
                                        control={
                                            <MedicalCheckbox
                                                id={"chkxAD"}
                                                checked={AD}
                                                onChange={(event, check) => {
                                                    setAD(check)
                                                }}
                                                iconStyle={{ fill: 'green' }}
                                            />
                                        }
                                        label={"AD"}
                                        labelPlacement={"end"}
                                    />
                                </Col>
                                <Col md={1}>
                                    <FormControlLabel
                                        id={"chkx_AM_FormLabel"}
                                        value={AM}
                                        control={
                                            <MedicalCheckbox
                                                id={"chkxAM"}
                                                checked={AM}
                                                onChange={(event, check) => {
                                                    setAM(check)
                                                }}
                                                iconStyle={{ fill: 'green' }}
                                            />
                                        }
                                        label={"AM"}
                                        labelPlacement={"end"}
                                    />
                                </Col>
                                <Col md={1}>
                                    <FormControlLabel
                                        id={"chkx_CT_FormLabel"}
                                        value={CT}
                                        control={
                                            <MedicalCheckbox
                                                disabled={true}
                                                id={"chkxCT"}
                                                checked={CT}
                                                onChange={(event, check) => {
                                                    setCT(check)
                                                }}
                                                iconStyle={{ fill: 'green' }}
                                            />
                                        }
                                        label={"CT"}
                                        labelPlacement={"end"}
                                    />
                                </Col>
                            </Row>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <br />
                                {isLoading ? <Spinner animation="border" variant="success" /> :
                                    <Button
                                        disabled={!dates.startDate || !dates.endDate}
                                        onClick={() => {
                                            downloadZIP();
                                        }}
                                        className="btn btn-primary text-white"
                                    >
                                        Generar y Descargar
                                    </Button>
                                }
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Container>
        </Fragment>
    )
}
export default RIPSpecificParameters